import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutComponent, MENU_ITEMS } from '@onrsr/ui/layout';
import { AppAbility } from './core/auth/ability';
import { menuItemsFor } from './config/menu';

/**
 * Authenticated shell. MENU_ITEMS is provided here rather than at root so the
 * menu is rebuilt from the current ability each time the shell is created.
 */
@Component({
  selector: 'app-shell',
  imports: [RouterOutlet, LayoutComponent],
  template: '<onrsr-layout><router-outlet /></onrsr-layout>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: MENU_ITEMS, useFactory: () => menuItemsFor(inject(AppAbility)) }],
})
export class AppShell {}
